module.exports = __webpack_public_path__ + "35e51b5692b37ada9f57cd0a3d043786.pdf";